import i18n from "i18next";

const changeLanguage = (lang) => {
    switch (lang) {
        case "ko":
        case "ko-kr":
        case undefined:
        case "":
            if (i18n.language === "ko_KR") break;
            i18n.changeLanguage("ko_KR");
            break;
        case "en-us":
            if (i18n.language === "en_US") break;
            i18n.changeLanguage("en_US");
            break;
        default:
            if (i18n.language === lang) break;
            i18n.changeLanguage(lang);
            break;
    }
};

export default changeLanguage;